import styled from "styled-components";
import {useContext} from "react";
import {AudioPlayerContext} from "./AudioPlayerContext";

export function TrackTime() {
  const { trackProgress } = useContext(AudioPlayerContext);

  return (
    <TrackTimeContainer>{
      Math.floor(trackProgress / 60)}:{("0" + Math.floor(trackProgress % 60)).slice(-2)
    }</TrackTimeContainer>
  )
}

const TrackTimeContainer = styled.div`
  font-family: 'Quattrocento', serif;
  text-align: end;
  width: 50px;
`
